import { defineMessages } from 'react-intl';

export default defineMessages({
    notificatonText: {
        id: 'tdic.email-notification.Email address needed',
        defaultMessage: 'No email address is on file for policy and billing notifications. Update your email for policies {link} individually by clicking Edit Policy Profile and completing a Profile Change.'
    }
});
